// extracted by mini-css-extract-plugin
export default {"root":"styles_root__BHVKY","modal-text":"styles_modal-text__Wcr+3"};